import React from 'react';

import {TypographyVariantsEnum} from '../../../../../utils/_enums/typeography-variants.enum';
import {Typography} from '../../../typography/typography';
import styles from './sales-box-footer.module.scss';

interface SalesBoxFooterProps {
    headline?: string;
    description?: string;
}

const SalesBoxFooter = (props: SalesBoxFooterProps): JSX.Element => {
    return (
        <div className={styles['footer']}>
            <Typography
                variant={TypographyVariantsEnum.CAPTION}
                className={styles['headline']}
                element={'span'}
            >
                {props.headline}
            </Typography>
            <Typography
                variant={TypographyVariantsEnum.CAPTION}
                element={'span'}
            >
                {props.description}
            </Typography>
        </div>
    );
};

export default SalesBoxFooter;
